import { useState } from "react";
import { InputFieldProps } from "../../types/componentsConstructors";
import { Container, Field } from "./InputFieldStyles";
import { shakeAnimation } from "../../styles/animations";
import { AnimatePresence, motion } from "framer-motion";
import {
  ContentWrapper,
  FieldWrapper,
  Icon,
  Label,
  Message,
} from "../ui/FormBaseStyles";

interface Props extends InputFieldProps {
  shakeTrigger?: number;
}

const InputField = ({
  label,
  type = "text",
  name,
  placeholder,
  required = false,
  icon,
  error,
  value,
  onChange,
  shakeTrigger = 0,
}: Props) => {
  const [focused, setFocused] = useState(false);

  const showError = !!error;

  return (
    <Container>
      <ContentWrapper>
        <Label>
          {label}
          {required && <span>*</span>}
        </Label>

        <motion.div
          key={shakeTrigger}
          animate={showError ? shakeAnimation : { x: 0 }}
          transition={{ duration: 0.3 }}
        >
          <FieldWrapper $focused={focused} $hasError={showError}>
            {icon && <Icon>{icon}</Icon>}
            <Field
              name={name}
              type={type}
              placeholder={placeholder}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              value={value}
              onChange={onChange}
              autoComplete="off"
              aria-invalid={showError}
              aria-describedby={showError ? `${name}-error` : undefined}
            />
          </FieldWrapper>
        </motion.div>

        <AnimatePresence>
          {showError && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <Message id={`${name}-error`}>{error}</Message>
            </motion.div>
          )}
        </AnimatePresence>
      </ContentWrapper>
    </Container>
  );
};

export default InputField;
